// src/plugins/apiClient.js or similar
import axios from 'axios'
import Cookies from 'js-cookie'
import router from '@/router'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000,
})

// ✅ Request interceptor to attach token from cookie
apiClient.interceptors.request.use((config) => {
  let user = Cookies.get('inquiry-user')

  if (user) {
    try {
      user = JSON.parse(user)
      if (user.authToken) {
        config.headers.Authorization = `Bearer ${user.authToken}`
      }
    } catch (e) {
      console.warn('Invalid cookie format', e)
    }
  }

  return config
})

// ✅ Response interceptor to handle 401 errors (expired token)
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token is expired or invalid, redirect to sign out page
      console.warn('Authentication failed - redirecting to sign out')
      router.push('/inquiry-my-signout')
    }
    return Promise.reject(error)
  }
)

export default apiClient
